import { render, staticRenderFns } from "./DependenciasModal.vue?vue&type=template&id=3678e308&scoped=true"
import script from "./DependenciasModal.vue?vue&type=script&lang=js"
export * from "./DependenciasModal.vue?vue&type=script&lang=js"
import style0 from "./DependenciasModal.vue?vue&type=style&index=0&id=3678e308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678e308",
  null
  
)

export default component.exports